import React, {memo, useCallback, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import NetworkMsgImage from "../../assets/img/network-message-box.png";
import NetworkMsgRevImage from "../../assets/img/network-message-box-reversed.png";
import VisibilityOn from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import {IconButton} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    chatBackground: {
        display: props => props.open ? '' : 'none',
        maxHeight: 500,
        flexDirection: 'column',
        right: props => props.index ? (0.25 * window.innerWidth * props.index) : 0,
        width: '24%',
        position: 'absolute',
        bottom: '0px',
        textAlign: 'center',
        backgroundSize: '100% 100%',
        alignItems: 'center',
        margin: '1px',
        opacity: '0.9',
        pointerEvents: 'all',
        backgroundImage: props => props.usersList ? `url(${NetworkMsgRevImage})` : `url(${NetworkMsgImage})`,
    },
    statusButton: {
        fontSize: '1.1vw',
        margin: 0,
        padding: 10,
        display: 'block',
        float: 'right'
    },
    statusIcon: {
        color: 'white'
    }
}));

const ChatLayout = props => {

    const classes = useStyles(props);
    const {open, closeModal, usersList, otherUser, inputComponent, users, hideStatus, setHideStatus} = props;
    const [collapse, collapseModal] = useState(false);

    const getName = user => user.FirstName + " " + user.LastName;


    const toggleStatus = useCallback(() => {
        setHideStatus(!hideStatus)
    }, [hideStatus])

    const StatusIcon = hideStatus ? VisibilityOff : VisibilityOn

    return (
        <div className={classes.chatBackground}
             style={{height: collapse ? '50px' : window.innerWidth * 0.4}}>
            <div className={'chat-header'}
                 style={{flexDirection: usersList && !collapse ? 'column-reverse' : 'row'}}
            >

                <div onClick={(e) => {
                    e.stopPropagation();
                    collapseModal(false)
                }} className={!collapse ? 'chat-online-users-u' : 'chat-online-users-c'}>
                    {usersList ? (users && users.length + ' online users') : getName(otherUser)}
                </div>


                <div className={'chat-actions-buttons'}>
                    <div className={'close-button'} style={{padding: '9.5px !important'}} onClick={closeModal}>X</div>
                    <div className={'close-button'} style={{padding: '9.5px !important'}} onClick={() => collapseModal(true)}>_</div>
                    {usersList && <>
                        <IconButton className={classes.statusButton} onClick={toggleStatus}>
                            <StatusIcon className={classes.statusIcon}/>
                        </IconButton>
                    </>}
                </div>


            </div>
            {!collapse && <div className={usersList ? 'users-custom-wrapper' : 'chat-message-custom-wrapper'}>
                {props.children}
            </div>}

            {(!collapse && inputComponent) &&
            <div style={{position: "absolute", bottom: 0, display: 'flex', width: '100%'}}>{inputComponent}</div>}

        </div>
    )
};

export default memo(ChatLayout);

